import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-carousel-modal',
  templateUrl: './carousel-modal.component.html',
  styleUrls: ['./carousel-modal.component.css']
})
export class CarouselModalComponent implements OnInit {
  @Input() carModals: any[];
  @Input() customOptions: any;
  @Input() message: any;
  sessionAttributes: any;
  @Output() suggestionMsgEv = new EventEmitter<any>();
  
  constructor() { }
  
  ngOnInit() {
  }
  
  sendMessage(message, divId, slotToElicit,textTitle) {
    const suggestionMsgDetails = {
      message,
      divId,
      slotToElicit,
      sessionAttributes:this.sessionAttributes,
      textTitle
    };
    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }
}
